import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useGrid, usePopup, useStore, useToast, useModal } from "@/comn/hooks";
import { BASE, APIS, SF_ORG_USR_SRCH, SG_ORG_USR_LIST } from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const OrgUsrList = (props: any) => {
    const pgeUid = "orgUsrLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    const form = {
        orgUsrSrch: useForm({
            defaultSchema: SF_ORG_USR_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        orgUsrLst: useGrid({
            defaultSchema: SG_ORG_USR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getOrgUsrLst: useFetch({
            api: (page = grid.orgUsrLst.page) => {
                return APIS.getOrgUsrtLst(form.orgUsrSrch.getValues(), page, grid.orgUsrLst.size);
            },
            enabled: comnUtils.isEmpty(form.orgUsrSrch.errors) && form.orgUsrSrch.isSubmitted,
            key: [grid.orgUsrLst.page, grid.orgUsrLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.orgUsrSrch.getValues(),
                    page: grid.orgUsrLst.page,
                    size: grid.orgUsrLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.orgUsrSrch.handleSubmit(
                () => {
                    grid.orgUsrLst.setPage(0);
                    fetch.getOrgUsrLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.orgUsrLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.com.00086" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_OrgUsrLst: {
            cell: {
                usrId: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.usrNm });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.orgUsrLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_ORG_USR_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.orgUsrSrch.schema.usrId}></Group.Control>
                                <Group.Control {...form.orgUsrSrch.schema.usrNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.orgUsrSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    {/* * */}
                    {params?.multiple === true && (
                        <Layout>
                            <Layout.Right>
                                <Button
                                    role="apply"
                                    onClick={() => {
                                        handler.click_Btn_Apply();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                    <Grid
                        {...grid.orgUsrLst.grid}
                        data={fetch.getOrgUsrLst.data?.orgUsrList}
                        render={render.grid_OrgUsrLst}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
